import { Box, Flex, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { LuMessageCircle } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { CompanionAvatar } from "src/components/CompanionAvatar";
import { GradientButton } from "src/components/GradientButton";
import { TAB_BAR_SPACE } from "src/layouts/AppLayout";
import { useChatStore } from "src/stores/chatStoreContext";
import { tap } from "src/utils/haptic";
import { shortTime } from "src/utils/time";

export const ChatsPage = observer(() => {
  const chatStore = useChatStore();
  const navigate = useNavigate();
  const recent = chatStore.recentChats;

  return (
    <Box pb={TAB_BAR_SPACE}>
      <Text
        px={5}
        pt={1}
        fontSize="28px"
        fontWeight="bold"
        letterSpacing="-0.02em"
      >
        Chats
      </Text>

      {recent.length === 0 ? (
        <Flex
          direction="column"
          align="center"
          textAlign="center"
          px={8}
          pt={24}
          gap={3}
          animation="tlRise 0.4s ease both"
        >
          <Flex
            boxSize="72px"
            borderRadius="full"
            bg="elevated"
            align="center"
            justify="center"
            color="accent"
          >
            <LuMessageCircle size={32} />
          </Flex>
          <Text fontSize="lg" fontWeight="semibold">
            No chats yet
          </Text>
          <Text color="muted" fontSize="sm" mb={3}>
            Pick a companion and say hi. Your chats show up here.
          </Text>
          <GradientButton width="auto" px={8} onClick={() => navigate("/")}>
            Discover companions
          </GradientButton>
        </Flex>
      ) : (
        <Box mt={2}>
          {recent.map(({ companion, last }, i) => (
            <Flex
              key={companion.id}
              as="button"
              width="100%"
              textAlign="left"
              align="center"
              gap={3}
              px={5}
              py={3}
              onClick={() => {
                tap();
                navigate(`/chat/${companion.id}`);
              }}
              _active={{ bg: "surface" }}
              transition="background 0.15s"
              animation="tlRise 0.35s ease both"
              style={{ animationDelay: `${Math.min(i, 8) * 40}ms` }}
            >
              <CompanionAvatar companion={companion} size="58px" ring />
              <Box
                flex="1"
                minW={0}
                borderBottomWidth={i === recent.length - 1 ? 0 : "1px"}
                borderColor="line"
                pb={3}
                pt={1}
              >
                <Flex justify="space-between" align="baseline" gap={2}>
                  <Text fontWeight="semibold">{companion.name}</Text>
                  <Text fontSize="xs" color="faint" flexShrink={0}>
                    {shortTime(last.sentAt)}
                  </Text>
                </Flex>
                <Text fontSize="sm" color="muted" truncate>
                  {last.from === "user" ? "You: " : ""}
                  {last.text}
                </Text>
              </Box>
            </Flex>
          ))}
        </Box>
      )}
    </Box>
  );
});
